import { render, staticRenderFns } from "./DashboardViewEditingFiltersExistingRule.vue?vue&type=template&id=87fd9b84"
import script from "./DashboardViewEditingFiltersExistingRule.vue?vue&type=script&lang=js"
export * from "./DashboardViewEditingFiltersExistingRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports